<template>
  <v-layout row wrap>
    <v-toolbar xs12 class="primary" dark dense card>
      <div class="text-lg-left beez-bold ">
        Chat with Andreena
      </div>
    </v-toolbar>
    <v-flex xs12>
      <div
        class="chat-fixed-background scrollbar scroll_beez chat"
        id="chat_container"
      >
        <v-list class="chat-list-container">
          <v-list-tile-content v-for="(item, i) in chats" :key="i + 1000">
            <template v-if="item.from !== 'Buzz'">
              <div class="chat-body" style="width:100%">
                <div class="bubble-right">
                  {{ item.message }}
                  <div class="bubble-timestamp">
                    <small class=" text-muted">{{ item.timestamp }}</small>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="chat-body">
                <div class="bubble-left">
                  {{ item.message }}
                  <div class="bubble-timestamp">
                    <small class=" text-muted">{{ item.timestamp }}</small>
                  </div>
                </div>
              </div>
            </template>
          </v-list-tile-content>
        </v-list>
      </div>
    </v-flex>
    <v-flex xs12>
      <v-card>
        <v-layout align-center justify-center row>
          <v-flex xs10 class="pa-2">
            <v-textarea
              placeholder="Type a message here"
              autofocus
              v-model="text"
              @keyup.enter="displayChat()"
              @input="readChat()"
              auto-grow
              rows="1"
              color="secondary"
            >
            </v-textarea>
          </v-flex>
          <v-flex xs2 class="pa-2">
            <v-btn flat icon @click="getVoice()">
              <v-icon medium :color="listening ? 'secondary' : 'secondary'">
                mic
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      drawer: null,
      text: '',
      listening: false,
      recognition: null
    }
  },
  updated() {
    let container = this.$el.querySelector('#chat_container')
    container.scrollTop = container.scrollHeight
  },
  computed: {
    ...mapState({
      chats: state => state.socket.chats
    })
  },
  mounted() {
    this.$store.dispatch('readChat')
    this.$store.dispatch('directMessage', 'Greetings!, how can I help you?')
  },

  created() {
    if (window.hasOwnProperty('webkitSpeechRecognition')) {
      this.recognition = new window.webkitSpeechRecognition()
      this.recognition.lang = 'en-US'
      this.recognition.interimResults = false
      this.recognition.maxAlternatives = 5
    } else {
      this.recognition = null
    }
  },

  methods: {
    displayChat() {
      if (this.text !== '') {
        let message = this.text
        this.text = ''
        this.$store.dispatch('sendChat', message)
      }
    },
    readChat() {
      this.$store.dispatch('readChat')
    },
    getVoice() {
      if (this.recognition) {
        this.listening = !this.listening
        if (!this.listening) {
          this.recognition.stop()
        } else {
          this.recognition.start()
        }
        this.recognition.onresult = event => {
          let message = event.results[0][0].transcript
          this.text = message
          this.$store.dispatch('sendChat', message)
          this.$store.dispatch('toggleVoice')
        }
      }
    }
  }
}
</script>

<style scoped>
.dh {
  min-width: 320px;
}

.chat-fixed-background {
  background: white;
}

.chat-list-container {
  background: white !important;
}

.search {
  width: 100%;
  position: relative;
}

.searchTerm {
  width: 95%;
  border: 1px solid orange;
  padding: 10px;
  height: 40px;
  border-radius: 50px;
  margin-top: 20px;
  outline: none;
  font-size: 16px;
  color: #fff;
}

.search-chat {
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
}
</style>
